import React from 'react';
import styled from 'styled-components';
import { isNumber } from 'lodash/fp';
import { Box, Grid, Divider as MuiDivider } from '@material-ui/core';
import { BillDetail, InfoLink } from '../../../../ui-kit';
import { OrderLine } from '../../../../ui-kit/BillDetail/types';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { routePaths } from '../../../../routePaths';
import { useUser } from '../../../../utils/hooks/auth';
import { useDateTimeService } from '../../../../utils/hooks/dateTimeService';
import { Bill as BillType } from '../../../../generated/graphql';

const Divider = styled(MuiDivider)`
  width: 100%;
`;

type Bill = Pick<BillType, 'id' | 'dicountedTotalValue' | 'roundedPrice' | 'total' | 'billNumber' | 'issuedUtc' | 'billState'>;

const OrderLineDetailListRow =
    ({ orderLines, bill }: { orderLines: OrderLine[]; bill: Bill }) => {
        const { priceService } = usePriceService();
        const { dateTimeService } = useDateTimeService();
        const { user } = useUser();

        const { dicountedTotalValue, roundedPrice, total } = bill;

        // eslint-disable-next-line no-nested-ternary
        const totalBill = isNumber(roundedPrice) ? roundedPrice : isNumber(dicountedTotalValue) ? dicountedTotalValue : total;

        return (
            <React.Fragment>
                <Grid item xs={12}>
                    <InfoLink
                        link={`${routePaths.bills}/${bill.id}`}
                        linkText={`${bill.billNumber}/${dateTimeService.localizeDate(bill.issuedUtc, user.cultureCode)}`}
                    />
                </Grid>
                {orderLines.map(orderLine => (
                    <Grid key={orderLine.id} item xs={12} sm={6} lg={3}>
                        <BillDetail {...orderLine} />
                    </Grid>
                ))}
                <Grid container alignContent='center'>
                    <Grid item xs={4}>
                        <Box display='flex' flexGrow='1' height='100%' alignItems='center'>
                            <Box flexGrow={1} alignItems='center'>
                                <Divider />
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <Box display='flex' justifyContent='center'>
                            {`${bill.billState} ${priceService.toLocaleString(totalBill)}`}
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <Box display='flex' flexGrow='1' height='100%' alignItems='center'>
                            <Box flexGrow={1} alignItems='center'>
                                <Divider />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    };

export default OrderLineDetailListRow;
